import React from 'react';

import CcassPlus from '../../assets/ccass_plus.svg';
import { uiConstants } from '../../constants';
import { useAnalytics } from '../../helpers/analytics.helper';
import { Analytics } from '../../shared/types';
import { ReactTable } from '../../types';

const CCASSShortcutCell: React.FC<ReactTable.CellProps> = ({
  dispatch,
  row: { isExpanded, index, original },
}) => {
  const exclusivelyToggleExpanded = (index, isExpanded) =>
    dispatch({
      type: 'setExpanded',
      expanded: { [index]: isExpanded },
    });
  const [queue] = useAnalytics();

  return (
    <div className="text-center">
      <img
        src={CcassPlus}
        style={{ cursor: 'pointer', height: '1rem' }}
        onClick={() => {
          exclusivelyToggleExpanded(
            index,
            isExpanded === uiConstants.MODE_CCASS_SUMMARY
              ? 0
              : uiConstants.MODE_CCASS_SUMMARY
          );
          if (isExpanded !== uiConstants.MODE_CCASS_SUMMARY) {
            queue(Analytics.ActionEnum.ClickCCASSSummary, original.stockCode);
          }
        }}
      />{' '}
    </div>
  );
};

export default CCASSShortcutCell;
